export const categories = [
  {
    id: 'swimwear',
    name: 'Swimwear',
    description: 'Swimsuits and beachwear',
    productCount: 12,
    image:
      'https://images.unsplash.com/photo-1563178406-4cdc2923acbc?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    description: 'Beach accessories',
    productCount: 18,
    image:
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'footwear',
    name: 'Footwear',
    description: 'Sandals and beach shoes',
    productCount: 8,
    image:
      'https://images.unsplash.com/photo-1603487742131-4160ec999306?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'souvenirs',
    name: 'Souvenirs',
    description: 'Memorable items from the beach',
    productCount: 10,
    image:
      'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?auto=format&fit=crop&q=80&w=800',
  },
]
